import VatTotal, { VatTotalNew } from './VatTotal'
import { InputTableHookFullProps } from '../../../../../baseComponents/TwinTable/InputTableLayout/InputTable/types'

const VatTableChildren: React.FC<InputTableHookFullProps> = ({ completeData, CurrencyId, eventFunctions, ...rest }) => {
    return (
        <VatTotal {...{ completeData, CurrencyId, ...rest }} />
    )
}

export const VatTableChildrenNew: React.FC<InputTableHookFullProps> = ({ completeData, CurrencyId, eventFunctions, ...rest }) => {
    return (
        <VatTotalNew {...{ completeData, CurrencyId, ...rest }} />
    )
}


export default VatTableChildren